module.exports = __webpack_public_path__ + "static/img/icon_ehp0520.84d50546.png";